import { render, staticRenderFns } from "./SquareComission.vue?vue&type=template&id=90f34bf0"
import script from "./SquareComission.vue?vue&type=script&lang=js"
export * from "./SquareComission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports